export const BOT_TESTER_API_VERSION = 1

export enum SEMANTIC_BOT_TESTER_API_VERSIONS {
  UNSUPPORTED_CHANNEL = 999
}
